import { GroupByMode, GroupSetting, TaskGroupBy } from '@griply/types';

const defaultGroupSetting: GroupSetting = {
  showEmptyGroups: false,
};

export const defaultTaskListGroupSettings: Record<TaskGroupBy, GroupSetting> = {
  [GroupByMode.None]: defaultGroupSetting,
  [GroupByMode.LifeArea]: defaultGroupSetting,
  [GroupByMode.Goal]: defaultGroupSetting,
  [GroupByMode.DayPart]: defaultGroupSetting,
  [GroupByMode.Type]: defaultGroupSetting,
  [GroupByMode.Priority]: defaultGroupSetting,
  [GroupByMode.Deadline]: defaultGroupSetting,
  [GroupByMode.DeadlineDeadline]: defaultGroupSetting,
  [GroupByMode.Tag]: defaultGroupSetting,
  [GroupByMode.Section]: defaultGroupSetting,
  [GroupByMode.CompletedDate]: defaultGroupSetting,
  [GroupByMode.UpcomingDeadline]: defaultGroupSetting,
};
